import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import DatabaseFunctions from '../../components/users/DatabaseFunctions'
import { uploadFileData, dbupload, getCurrentUser, getTeams } from '../../actions/userActions'
import {
    getDbJobsSiteWide,
    getDbJobHistorySiteWide,
    getDataSources,
    getDatabaseJobFiles,
    downloadDatabaseJobFile,
    selfServiceChangeFilesPage,
    selfServiceChangeJobsPage,
    selfServiceChangeHistoriesPage,
    openEditNewWizardFile
} from '../../actions/dbFunctionsActions'
import { showPopup } from "../../actions/uiActions"
import { doesThisUserHaveThisAuthorization } from '../../components/utilities/helperFunctions'

function DatabaseFunctionsContainer(props) {
    const [allowedRoles] = useState(['IEAdmin','ClientAdmin'])
    const [jobs, setJobs] = useState([])
    const [histories, setHistories] = useState([])
    const [files, setFiles] = useState([])
    const [hasSpecialPermission, setHasSpecialPermission] = useState(false)
    const [performingJob, setPerformingJob] = useState(false)

    // trigger on component mount
    useEffect(() => {
        if (jobs.length === 0) {
            props.getDbJobsSiteWide(-1)
        }
        if (histories.length === 0) {
            props.getDbJobHistorySiteWide(-1)
        }
        if (files.length === 0 && props.selfServeJobs.globalFiles.length === 0) {
            props.getDatabaseJobFiles()
        } else if (props.selfServeJobs.globalFiles.length > 0) {
            setFiles(props.selfServeJobs.globalFiles)
        }

        if (props.teamList.length === 0) {
            props.getTeams()
        }
    }, [])

    useEffect(() => {
        if (props.selfServeJobs.jobs.length > 0 || (jobs.length !== props.selfServeJobs.jobs.length)) {
            setJobs(props.selfServeJobs.jobs)
        }
    }, [props.selfServeJobs.jobs])

    useEffect(() => {
        if (props.selfServeJobs.histories.length > 0  || (histories.length !== props.selfServeJobs.histories.length)) {
            setHistories(props.selfServeJobs.histories)
        }
    }, [props.selfServeJobs.histories])

    useEffect(() => {
        if (props.selfServeJobs.globalFiles.length > 0 || (files.length !== props.selfServeJobs.globalFiles.length)) {
            setFiles(props.selfServeJobs.globalFiles)
        }
    }, [props.selfServeJobs.globalFiles])

    useEffect(() => {
        if (performingJob && !props.selfServeJobs.performingJob) {
            setHistories([])
            props.getDbJobHistorySiteWide(-1)
        }
        
        setPerformingJob(props.selfServeJobs.performingJob)
    }, [props.selfServeJobs.performingJob])

    useEffect(() => {
        if (props.currentUser !== null) {
            if (props.currentUser["applicationUserClaims"] !== null) {
                let applicationUserClaims = props.currentUser["applicationUserClaims"]
                applicationUserClaims.forEach(a => {
                    if (a["claimValue"] === "DatabaseFunctions") {
                        setHasSpecialPermission(true)
                    }
                })
            }
        }
    }, [props.currentUser])

    if (props.currentUser === null) {
        props.getCurrentUser(props.userID)
    }

    if (allowedRoles.includes(props.role)) {
        return <div className="main">
            <DatabaseFunctions 
                uploadFileData={props.uploadFileData}
                dbupload={props.dbupload}
                dbList={props.dbList}
                showPopup={props.showPopup}
                selfServeJobs={props.selfServeJobs}
                jobs={jobs}
                histories={histories}
                getDataSources={props.getDataSources}
                globalFiles={files}
                downloadFile={props.downloadDatabaseJobFile}
                role={props.role}
                selfServiceChangeFilesPage={props.selfServiceChangeFilesPage}
                selfServiceChangeJobsPage={props.selfServiceChangeJobsPage}
                selfServiceChangeHistoriesPage={props.selfServiceChangeHistoriesPage}
                openEditNewWizardFile={props.openEditNewWizardFile} />
        </div>
    } else if (hasSpecialPermission) {
        return <div className="main">
            <DatabaseFunctions 
                uploadFileData={props.uploadFileData}
                dbupload={props.dbupload}
                dbList={props.dbList}
                showPopup={props.showPopup}
                selfServeJobs={props.selfServeJobs}
                jobs={jobs}
                histories={histories}
                getDataSources={props.getDataSources}
                globalFiles={files}
                downloadFile={props.downloadDatabaseJobFile}
                role={props.role}
                selfServiceChangeFilesPage={props.selfServiceChangeFilesPage}
                selfServiceChangeJobsPage={props.selfServiceChangeJobsPage}
                selfServiceChangeHistoriesPage={props.selfServiceChangeHistoriesPage}
                openEditNewWizardFile={props.openEditNewWizardFile} />
        </div>
    } else {
        return null
    }
}

function mapDispatchToProps(dispatch) {
    return {
        ...bindActionCreators({ uploadFileData, dbupload, showPopup, getDbJobsSiteWide, getDbJobHistorySiteWide, getDataSources, getDatabaseJobFiles, downloadDatabaseJobFile, doesThisUserHaveThisAuthorization, getCurrentUser, getTeams, selfServiceChangeFilesPage, selfServiceChangeJobsPage, selfServiceChangeHistoriesPage, openEditNewWizardFile }, dispatch)
    }
}

function mapStateToProps(state) {
    return {
        role: state.users.role,
        dbList: state.users.custDBList,
        selfServeJobs: state.selfServeJobs,
        currentUser: state.users.currentUser,
        userID: state.users.userID,
        teamList: state.users.teamList
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(DatabaseFunctionsContainer);